import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { AlternateLink } from "../components/sso/alternate_link";
import { EmailLoginForm } from "../components/sso/email_login_form";
import { OrgWrapper } from "../components/sso/org_wrapper";
import { Title } from "../components/sso/title";
import { LoginStore } from "../store/login";

import { OrgLogin } from "./org_login";

const LoginPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const isSingleOrgEnv = !!window.context?.isSingleOrgEnv;
  const isSSOEnabled = !!window.context?.enableSSO;

  const onSSOClick = () => () => {
    dispatch(LoginStore.actions.clearError());
    history.push("/sso");
  };

  if (isSingleOrgEnv) return <OrgLogin />;

  return (
    <OrgWrapper>
      <Title text="Sign in to Forum" />
      <EmailLoginForm />
      {isSSOEnabled ? (
        <AlternateLink text="Sign in with SSO Provider" onClick={onSSOClick} id="js-sso" />
      ) : null}
    </OrgWrapper>
  );
};

export { LoginPage };
